import { LessonPassportInfoItem, Text, useIntl } from 'platform-components/common';
import React from 'react';

import { getSpecCourseDatesStr } from 'common.components/spec-course/utils';

interface Props {
    beginDate: Date | null;
    endDate: Date | null;
}

export const SpecCourseLessonViewPassportDates = ({ beginDate, endDate }: Props) => {
    const intl = useIntl();

    const label = intl.formatMessage({ id: 'lessonPassport.dates.label' });
    const dates = getSpecCourseDatesStr(beginDate, endDate, intl);

    return (
        <LessonPassportInfoItem label={label}>
            <Text size={Text.SIZE.XL} weight={Text.WEIGHT.M}>
                {dates}
            </Text>
        </LessonPassportInfoItem>
    );
};
